var _slicedToArray = require("/builds/orgs/panel/participatiepanel.nl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = global || self, global.Ola = factory());
})(this, function () {
  "use strict";

  var position = function position(x0, v0, t1, t) {
    var a = (v0 * t1 + 2 * x0) / Math.pow(t1, 3);
    var b = -(2 * v0 * t1 + 3 * x0) / Math.pow(t1, 2);
    var c = v0;
    var d = x0;
    return a * Math.pow(t, 3) + b * Math.pow(t, 2) + c * t + d;
  };

  var speed = function speed(x0, v0, t1, t) {
    var a = (v0 * t1 + 2 * x0) / Math.pow(t1, 3);
    var b = -(2 * v0 * t1 + 3 * x0) / Math.pow(t1, 2);
    var c = v0;
    return 3 * a * Math.pow(t, 2) + 2 * b * t + c;
  };

  var each = function each(values, cb) {
    var multi = typeof values === "number" ? {
      value: values
    } : values;
    Object.entries(multi).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return cb(value, key);
    });
  };

  function Single(init, time) {
    this.start = new Date() / 1e3;
    this.time = time;
    this.from = init;
    this.current = init;
    this.to = init;
    this.speed = 0;
  }

  Single.prototype.get = function (now) {
    var t = now / 1e3 - this.start;

    if (t < 0) {
      throw new Error("Cannot read in the past");
    }

    if (t >= this.time) {
      return this.to;
    }

    return this.to - position(this.to - this.from, this.speed, this.time, t);
  };

  Single.prototype.getSpeed = function (now) {
    var t = now / 1e3 - this.start;

    if (t >= this.time) {
      return 0;
    }

    return speed(this.to - this.from, this.speed, this.time, t);
  };

  Single.prototype.set = function (value, time) {
    var now = new Date();
    var current = this.get(now);
    this.speed = this.getSpeed(now);
    this.start = now / 1e3;
    this.from = current;
    this.to = value;

    if (time) {
      this.time = time;
    }

    return current;
  };

  function Ola(values) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

    if (typeof values === "number") {
      values = {
        value: values
      };
    }

    each(values, function (init, key) {
      var value = new Single(init, time / 1e3);
      Object.defineProperty(values, "_" + key, {
        value: value
      });
      Object.defineProperty(values, "$" + key, {
        get: function get() {
          return value.to;
        }
      });
      Object.defineProperty(values, key, {
        get: function get() {
          return value.get(new Date());
        },
        set: function set(val) {
          return value.set(val);
        },
        enumerable: true
      });
    });
    Object.defineProperty(values, "get", {
      get: function get() {
        return function () {
          var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "value";
          var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
          return this["_" + name].get(now);
        };
      }
    });
    Object.defineProperty(values, "set", {
      get: function get() {
        return function (values) {
          var _this = this;

          var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          each(values, function (value, key) {
            _this["_" + key].set(value, time / 1e3);
          });
        };
      }
    });
    return values;
  }

  return Ola;
});